<!--
  Sub-modale "Conferma spedizione" — quarto step wizard picking (v2.11.0 J.4.b).
  Diakonix native modal pattern (z-index 2100).

  Pattern: form indirizzo destinazione + select corriere + bottoni
  Verifica / Genera etichetta / Stampa firma.
-->
@if (isShipOn) {
  <div class="cs-backdrop" (click)="close()">
    <div
      class="cs-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cs-title"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <header class="cs-header">
        <div class="cs-title-block">
          <h2 id="cs-title">🚚 Conferma spedizione</h2>
          @if (order?.or_order_number) {
            <p class="cs-subtitle">
              Ordine n° <strong>{{ order.or_order_number }}</strong>
            </p>
          }
        </div>
        <button
          type="button"
          class="cs-close"
          aria-label="Chiudi"
          (click)="close()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <!-- Body -->
      <div class="cs-body">
        @if (loading) {
          <div class="cs-loading">
            <i class="bx bx-loader-alt bx-spin"></i>
            Caricamento...
          </div>
        } @else if (order && orderToUpdate) {

          <!-- Sezione: Destinazione -->
          <section class="cs-section">
            <h3 class="cs-section-title">
              <i class="bx bx-map"></i> Destinazione
            </h3>

            <div class="cs-fields">
              <label class="cs-field cs-field--span-2">
                <span class="cs-field-label">Cliente</span>
                <input
                  type="text"
                  class="cs-input"
                  [(ngModel)]="orderToUpdate.or_shipping_customer"
                />
              </label>

              <label class="cs-field cs-field--span-2">
                <span class="cs-field-label">Indirizzo</span>
                <input
                  type="text"
                  class="cs-input"
                  [(ngModel)]="orderToUpdate.or_shipping_address"
                />
              </label>

              <label class="cs-field">
                <span class="cs-field-label">Città</span>
                <input
                  type="text"
                  class="cs-input"
                  [(ngModel)]="orderToUpdate.or_shipping_city"
                />
              </label>

              <label class="cs-field cs-field--narrow">
                <span class="cs-field-label">CAP</span>
                <input
                  type="text"
                  class="cs-input"
                  [(ngModel)]="orderToUpdate.or_shipping_zip"
                />
              </label>

              <label class="cs-field cs-field--narrow">
                <span class="cs-field-label">Prov.</span>
                <input
                  type="text"
                  class="cs-input"
                  [(ngModel)]="orderToUpdate.or_shipping_prov"
                  maxlength="2"
                />
              </label>

              <label class="cs-field">
                <span class="cs-field-label">Nazione</span>
                <input
                  type="text"
                  class="cs-input"
                  [(ngModel)]="orderToUpdate.or_shipping_country"
                />
              </label>

              <label class="cs-field cs-field--span-2">
                <span class="cs-field-label">Note</span>
                <input
                  type="text"
                  class="cs-input"
                  [(ngModel)]="orderToUpdate.or_note"
                  placeholder="Note di spedizione (opzionale)"
                />
              </label>
            </div>

            <div class="cs-address-status">
              @if (correctAddress) {
                <span class="cs-badge cs-badge--ok">
                  <i class="bx bx-check-circle"></i> Indirizzo completo
                </span>
              } @else {
                <span class="cs-badge cs-badge--warn">
                  <i class="bx bx-info-circle"></i> Compila tutti i campi obbligatori
                </span>
              }
            </div>
          </section>

          <!-- Sezione: Corriere -->
          <section class="cs-section">
            <h3 class="cs-section-title">
              <i class="bx bx-package"></i> Corriere
            </h3>

            <label class="cs-field">
              <span class="cs-field-label">Seleziona corriere</span>
              <select
                class="cs-input"
                [(ngModel)]="orderToUpdate.or_carrier_id"
              >
                <option [ngValue]="null">— Seleziona —</option>
                @for (carrier of carriers; track carrier.carrier_id) {
                  <option [ngValue]="carrier.carrier_id">
                    {{ carrier.carrier_desc }}
                  </option>
                }
                <option [ngValue]="'Other'">Altro</option>
              </select>
            </label>

            @if (orderToUpdate.or_carrier_id === 'Other' || orderToUpdate.or_carrier_other) {
              <label class="cs-field">
                <span class="cs-field-label">Specifica corriere</span>
                <input
                  type="text"
                  class="cs-input"
                  [(ngModel)]="orderToUpdate.or_carrier_other"
                  placeholder="Nome corriere"
                />
              </label>
            }
          </section>
        }
      </div>

      <!-- Footer -->
      <footer class="cs-footer">
        @if (canGenerate && !isLabelGenerated) {
          <button
            type="button"
            class="cs-btn cs-btn--label"
            (click)="generateLabel()"
          >
            <i class="bx bx-printer"></i>
            Genera etichetta
          </button>
        }

        <button
          type="button"
          class="cs-btn cs-btn--update"
          [disabled]="!order"
          (click)="updateCor()"
        >
          <i class="bx bx-refresh"></i>
          Aggiorna corriere
        </button>

        <button
          type="button"
          class="cs-btn cs-btn--confirm"
          [disabled]="!correctAddress"
          (click)="check()"
        >
          <i class="bx bx-check-circle"></i>
          Verifica & salva
        </button>
      </footer>
    </div>
  </div>
}

<!-- Sub-modale confirm-courrier (z-index 2200) -->
@if (modalService.isCourOn) {
  <app-confirm-courrier></app-confirm-courrier>
}
